import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';

import { FaMobileScreen } from 'react-icons/fa6';



const Banner = () => {

  return (
<section className="banner">
  <div className='content'>

    <Heading 
      title={"Drive Your Way with Comfort & Confidence"} 
      span={"Reliable Car Rentals"} 
      linear 
      sideHeading 
    />

    {/* Contact Information */}
    <div className="rental-call">
      <div className="icon"><FaMobileScreen /></div>
      <span>111-222-333</span>
    </div>

    <Button link={"Car-Booking"} title={"Book Your Ride"} />

  </div>
</section>

  );
};

export default Banner;